import React from "react";
import { Box, Typography, Button } from "@mui/material";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { useTranslation } from "react-i18next";

export default function ClassCard({
  image,
  fallbackImage,
  title,
  subjectId,
  teacherName,
  fileCount = 0,
  onView,
  viewLabel,
}) {
  const { t } = useTranslation();
  const filesLabel = Number(fileCount) === 1 ? t("1 file") : t("{{count}} files", { count: fileCount });

  return (
    <Box
      sx={{
        borderRadius: 1,
        overflow: "hidden",
        border: "1px solid #dce8f8",
        bgcolor: "#fff",
        boxShadow: "0 8px 20px rgba(8, 26, 74, 0.035)",
        display: "grid",
        minWidth: 0,
      }}
    >
      <Box sx={{ position: "relative", height: { xs: 144, md: 126 } }}>
        <img
          src={image || fallbackImage}
          alt={title}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Box>
      <Box sx={{ px: 1.5, pt: 1.25, pb: 1.25, display: "grid", gap: 0.8, minWidth: 0 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontWeight: 750,
              color: "#081a4a",
              fontSize: 14.25,
              lineHeight: 1.22,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {title}
          </Typography>
          <Typography sx={{ color: "#49699f", fontSize: 12, fontWeight: 600, mt: 0.15 }}>
            {subjectId || t("No subject")}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr) minmax(0, 0.75fr)",
            gap: 1,
            alignItems: "center",
            color: "#49699f",
            fontSize: 11.5,
            fontWeight: 700,
            minWidth: 0,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0 }}>
            <PersonOutlineRoundedIcon sx={{ fontSize: 16, color: "#5578b0", flexShrink: 0 }} />
            <Typography
              component="span"
              sx={{
                color: "inherit",
                fontSize: "inherit",
                fontWeight: "inherit",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                minWidth: 0,
              }}
            >
              {teacherName || t("Teacher")}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0 }}>
            <InsertDriveFileOutlinedIcon sx={{ fontSize: 16, color: "#5578b0", flexShrink: 0 }} />
            <Typography
              component="span"
              sx={{
                color: "inherit",
                fontSize: "inherit",
                fontWeight: "inherit",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                minWidth: 0,
              }}
            >
              {filesLabel}
            </Typography>
          </Box>
        </Box>

        <Button
          variant="text"
          onClick={onView}
          endIcon={<ArrowForwardRoundedIcon sx={{ fontSize: 18 }} />}
          sx={{
            justifySelf: "center",
            minHeight: 28,
            px: 1,
            py: 0,
            mt: 0.4,
            fontWeight: 800,
            fontSize: 12.75,
            color: "#006df0",
            textTransform: "none",
            "& .MuiButton-endIcon": { ml: 0.75 },
            "&:hover": { bgcolor: "transparent", color: "#0057c2" },
          }}
        >
          {viewLabel}
        </Button>
      </Box>
    </Box>
  );
}
